import React from "react";
import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { FiMoreHorizontal } from "react-icons/fi";

import AppMenu from "../../menu";
import { useSelector } from "react-redux";
import { getEnrollees } from "../../../store/enrollee";
import { getFormatedDate } from "../../../utils/constants";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  tableRow: {
    "& th": {
      color: "#E6072C",
      whiteSpace: "nowrap",
    },
  },

  pending: {
    color: "#FFA800",
    backgroundColor: "#FDF7EB",
    borderRadius: "10px",
    padding: "5px 15px",
    textTransform: "capitalize",
  },
  approved: {
    color: "#25B273",
    backgroundColor: "#E3F9F1",
    borderRadius: "10px",
    padding: "5px 15px",
    textTransform: "capitalize",
  },
  inactive: {
    color: "#8B8888",
    backgroundColor: "rgba(139, 136, 136, 0.1)",
    borderRadius: "10px",
    padding: "5px 15px",
    textTransform: "capitalize",
  },
  declined: {
    color: "#8B8888",
    backgroundColor: "rgba(139, 136, 136, 0.1)",
    borderRadius: "10px",
    padding: "5px 15px",
    textTransform: "capitalize",
  },
});

const Appointments = ({ onShowAppointmentDetails }) => {
  const classes = useStyles();
  const enrollees = useSelector(getEnrollees);
  
  const appointmentHistory = enrollees.data
    ? enrollees.data.appointment_requests_history
    : [];

    console.log(appointmentHistory);
  return appointmentHistory.length === 0 ? (
    <div className="text-center font-bold">No Appointment History</div>
  ) : (
    <Table className={classes.table} aria-label="simple table">
      <TableHead>
        <TableRow className={classes.tableRow}>
          <TableCell>Hospital Name</TableCell>
          <TableCell align="left">Request Date</TableCell>
          <TableCell align="left">Who to see?</TableCell>
          <TableCell align="left">Request Status</TableCell>
          <TableCell />
        </TableRow>
      </TableHead>
      <TableBody>
        {appointmentHistory.map((row) => (
          <TableRow key={row.id}>
            <TableCell component="th" scope="row">
              {row.hospital_name}
            </TableCell>
            <TableCell align="left">
              {getFormatedDate(row.created_date)}
            </TableCell>
            <TableCell align="left">{row.doctor_name || "No doctor"}</TableCell>
            <TableCell align="left">
              <span className={classes[row.status]}>{row.status}</span>
            </TableCell>
            <TableCell align="left">
              <AppMenu
                menu_name_or_icon={
                  <button>
                    <FiMoreHorizontal size="1.3em" color="#A8A8A8" />
                  </button>
                }
                item_names={[
                  {
                    "View Details": () =>
                      onShowAppointmentDetails(true, row.id, "appointments"),
                  },
                ]}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default Appointments;
